import { useContext } from 'react';

import { OrderContext as BaseOrderContext } from 'modules/account/orderModule/common/providers/OrderProvider/OrderContext';

import { OrderContext } from './orderContext';

export const useOrderContext = () => {
  const context = useContext(OrderContext);

  const baseContext = useContext(BaseOrderContext);

  if (!context || !baseContext) {
    throw new Error('useOrderContext must be used within an OrderProvider');
  }
  return { ...baseContext, ...context };
};
